import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeReimbursementModal, fetchReimbursement, openReimbursementModal } from "./store/reimbursementSlice";
import ReimbursementDataTable from "./ReimbursementDataTable";
import AddReimbursement from "./AddReimbursement";

const Reimbursement = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.reimbursementData || {});

  useEffect(() => {
    dispatch(fetchReimbursement());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Reimbursement"
            title="Dashboard"
            subtitle="Reimbursement"
            name="Import Reimbursement"
            onAddClick={() => dispatch(openReimbursementModal())}
          />

          <ReimbursementDataTable data={data} loading={loading} />

          <AddReimbursement
            show={isModalOpen}
            onClose={() => dispatch(closeReimbursementModal())}
          />
        </div>
      </div>
    </div>
  );
};

export default Reimbursement;
